import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { PlusCircle, Trash } from "@phosphor-icons/react";

export default function ShopCategories() {
  const [cats, setCats] = useState([]);
  const [name, setName] = useState("");
  const [icon, setIcon] = useState("");

  const load = async () => setCats((await api.get("/categories")).data);
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!name) return;
    try {
      await api.post("/categories", { name, icon });
      setName(""); setIcon("");
      toast.success("Category added");
      load();
    } catch { toast.error("Failed"); }
  };

  const del = async (id) => {
    if (!confirm("Delete this category?")) return;
    await api.delete(`/categories/${id}`);
    load();
  };

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-5">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-black tracking-tight">Categories</h1>
        <p className="text-gray-600 text-sm">{cats.length} categories</p>
      </div>

      <form onSubmit={add} className="qd-card p-4 grid sm:grid-cols-[1fr_1fr_auto] gap-3">
        <input className="qd-input" placeholder="Category name (e.g. Fruits)"
          value={name} onChange={(e) => setName(e.target.value)} data-testid="cat-name" />
        <input className="qd-input" placeholder="Icon URL (optional)"
          value={icon} onChange={(e) => setIcon(e.target.value)} data-testid="cat-icon" />
        <button className="qd-btn-primary inline-flex items-center gap-2" data-testid="cat-add-btn">
          <PlusCircle weight="bold" size={18} /> Add
        </button>
      </form>

      <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {cats.map((c) => (
          <div key={c.id} className="qd-card p-4 flex items-center gap-3" data-testid={`cat-card-${c.id}`}>
            <div className="w-12 h-12 rounded-xl bg-gray-100 flex items-center justify-center overflow-hidden">
              {c.icon ? <img src={c.icon} alt="" className="w-8 h-8 object-contain" /> : <span className="text-xl">📦</span>}
            </div>
            <div className="flex-1">
              <div className="font-semibold">{c.name}</div>
              <div className="text-xs text-gray-500">Active</div>
            </div>
            <button onClick={() => del(c.id)} className="text-red-500" data-testid={`cat-del-${c.id}`}><Trash size={18} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
